export const TEACHER_MODE_LABEL = 'Teacher mode';
